
import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import reactDom from 'react-dom';

function ContactForm(props)
{
    const formRef = useRef(null);

    const [host, setHost] = useState('');
    const [isProcess, setIsProcess] = useState(false);

    const [errors, setErrors] = useState({
        name: '',
        email: '',
        company: '',
        phone: '',
        website: '',
        message: '',
        // captcha: ''
    });

    const [captcha, setCaptcha] = useState({
        img: '',
        key: ''
    })

    const [message, setMessage] = useState('');

    useEffect(() => {
        let h = document.querySelector('meta[name="host"]').content;
        setHost(h);

        refreshCaptcha();
    }, [])

    const refreshCaptcha = () => {
        axios.get(host+'/captcha/api/mini')
        .then(res => {
            setCaptcha(res.data)
        })
    }

    const handleSubmit = e => {
        e.preventDefault();

        setIsProcess(true);

        setErrors({
            name: '',
            email: '',
            company: '',
            phone: '',
            website: '',
            message: '',
            // captcha: ''
        });

        setMessage('');

        let data = new FormData(e.target)

        axios.post(host+'/contact', data)
        .then(res => {
            setIsProcess(false);
            refreshCaptcha();
            if (res.data.message) {
                setMessage(res.data.message);
                formRef.current.reset();
            }
        })
        .catch(err => {
            setIsProcess(false);
            refreshCaptcha();
            if (err.response.data.errors)
            {
                setErrors(err.response.data.errors)
            }
        })
    }

    return (
        <form onSubmit={handleSubmit} ref={formRef}>
            <div className="mb-3 form-floating">
                <input className="form-control" type="text" name="name" id="name" placeholder="Name" />
                <label htmlFor="name" className="cl-orange">Name*</label>
                <small className="text-light">{errors.name}</small>
            </div>

            <div className="mb-3 form-floating">
                <input className="form-control" type="email" id="email" name="email" placeholder="Email"/>
                <label htmlFor="email" className="cl-orange">Email*</label>
                <small className="text-light">{errors.email}</small>
            </div>

            <div className="mb-3 form-floating">
                <input className="form-control" type="text" id="phone" name="phone" placeholder="Phone"/>
                <label htmlFor="phone" className="cl-orange">Phone*</label>
                <small className="text-light">{errors.phone}</small>
            </div>

            <div className="mb-3 form-floating">
                <input className="form-control" type="text" id="company" name="company" placeholder="Company Name"/>
                <label htmlFor="company" className="cl-orange">Company Name</label>
                <small className="text-light">{errors.company}</small>
            </div>

            <div className="mb-3 form-floating">
                <textarea className="form-control" name="message" id="inputMessage" placeholder="Leave us a message..."></textarea>
                <label htmlFor="inputMessage" className="cl-orange">Enquiries</label>
                <small className="text-light">{errors.message}</small>
            </div>

            {/* <div className="mb-3">
                <div className="row row-cols-1 g-2">
                    <div className="col">
                        <img src={captcha.img} id="captcha" alt="captcha" height="50"/>
                        <button type="button" onClick={refreshCaptcha} className="btn btn-order ms-2">Refresh Captcha</button>
                    </div>
                    <div className="col">
                        <input type="hidden" name="key" value={captcha.key} />
                        <div className="form-floating">
                            <input className="form-control" type="text" id="captcha" name="captcha" placeholder="Captcha"/>
                            <label htmlFor="captcha" className="cl-orange">Captcha</label>
                            <small className="text-light">{errors.captcha}</small>
                        </div>
                    </div>
                </div>
            </div> */}

            <div className="form-group mb-4">
                <small className="text-light">{message}</small>
            </div>

            <div className="form-group">
                <button type="submit" className={`btn btn-order mt-3 ${isProcess ? 'disabled' : ''}`} disabled={isProcess}>
                    {isProcess && 'Processing ...'}
                    {!isProcess && 'Submit'}
                </button>
            </div>
        </form>
    )
}

const container = document.querySelector('#contactForm');
reactDom.render(<ContactForm />, container);
